import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { RegisterSelectMethod } from '../actions/register';

@Component({
  selector: 'spaq-register-page',
  template: `
    <spaq-choose-method (selectMethod)="onSelectMethod($event)"></spaq-choose-method>
  `,
  styles: [],
})
export class RegisterPageComponent implements OnInit {
;

  constructor(private store: Store<any>) {
  }

  ngOnInit() {
  }

  onSelectMethod($event) {
    this.store.dispatch(new RegisterSelectMethod($event));
  }
}



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/register/containers/register-page.component.ts